var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fd-detail-main"},[(_vm.spdz && _vm.spdz!=='')?_c('div',{staticClass:"fd-voice-bg"},[_c('video',{attrs:{"src":_vm.spdz,"controls":"controls","autoplay":"autoplay"}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }